import { render, staticRenderFns } from "./component-table-list.vue?vue&type=template&id=16d5cb50&scoped=true&"
import script from "./component-table-list.vue?vue&type=script&lang=js&"
export * from "./component-table-list.vue?vue&type=script&lang=js&"
import style0 from "./component-table-list.vue?vue&type=style&index=0&id=16d5cb50&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d5cb50",
  null
  
)

export default component.exports